/** Derive the three contiguous sector durations from a canonical lap. */
export function deriveSectorTicks(checkpoints) {
    if (checkpoints.length !== 4)
        throw new Error("A canonical lap requires exactly four checkpoints");
    const [start, firstSector, secondSector, finish] = checkpoints;
    if (!start || !firstSector || !secondSector || !finish)
        throw new Error("A canonical lap requires four checkpoint boundaries");
    const expected = [0, 1, 2, 0];
    for (const [index, checkpoint] of checkpoints.entries()) {
        if (checkpoint.index !== expected[index])
            throw new Error("Canonical lap checkpoints are out of order");
        if (!Number.isSafeInteger(checkpoint.tick) || checkpoint.tick < 0)
            throw new Error("Canonical lap checkpoint ticks must be safe integers");
        const previous = checkpoints[index - 1];
        if (index > 0 && previous && checkpoint.tick <= previous.tick)
            throw new Error("Canonical lap checkpoint ticks must increase strictly");
    }
    const sectors = [
        firstSector.tick - start.tick,
        secondSector.tick - firstSector.tick,
        finish.tick - secondSector.tick,
    ];
    if (sectors.some((ticks) => !Number.isSafeInteger(ticks) || ticks <= 0))
        throw new Error("Canonical lap sectors must be positive safe integers");
    if (sectors[0] + sectors[1] + sectors[2] !== finish.tick - start.tick)
        throw new Error("Canonical lap sector ticks do not sum to lap ticks");
    return sectors;
}
export function ticksToMilliseconds(ticks, tickRate) {
    if (!Number.isSafeInteger(ticks) || ticks < 0)
        throw new Error("Ticks must be a non-negative safe integer");
    if (!Number.isFinite(tickRate) || tickRate <= 0)
        throw new Error("Tick rate must be positive");
    return Math.round((ticks * 1000) / tickRate);
}
export function sectorTicksToMilliseconds(sectors, tickRate) {
    return [
        ticksToMilliseconds(sectors[0], tickRate),
        ticksToMilliseconds(sectors[1], tickRate),
        ticksToMilliseconds(sectors[2], tickRate),
    ];
}
export function classifySector(current, personal, global) {
    if (!Number.isFinite(current) || current < 0)
        return "neutral";
    // A comparison is meaningful only when both laps that define the product
    // reference snapshot are available. A lone PB/global would otherwise make
    // the color depend on which side happened to be populated first.
    if (personal === null ||
        personal === undefined ||
        global === null ||
        global === undefined ||
        !Number.isFinite(personal) ||
        !Number.isFinite(global))
        return "neutral";
    if (current < global)
        return "purple";
    if (current < personal)
        return "green";
    return "red";
}
